import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { Link } from 'react-router-dom'


const AnalyticsButton = styled.a`
  color: ${({ theme }) => theme.analyticsButtonColor};
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  overflow: hidden;
  outline: none;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  padding: 0.8rem 1.2rem;
  font-size: 1.75rem;

  /* Tablets */
  @media (max-width: 1400px) {
    font-size: 1.5rem;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.75rem;
  }
`

export default AnalyticsButton
